/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
/*
    xng-change:
    * Add a common style to the autocompleteBrands, autocompleteCategories, and autocompleteContent sections.
*/
import { autocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { autocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { StyledButton } from "@insite/mobius/Clickable";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { mergeWithCss } from "@monsma/XDL/Utilities";
import { css } from "styled-components";

const linkStyle = {
    size: 13,
    lineHeight: "20px",
    weight: 500,
};

autocompleteCategoriesStyles.headerText = {
    variant: "h6",
    css: css`
        margin: 20px 0 15px;
        text-align: left;
    `,
};

autocompleteCategoriesStyles.link = {
    typographyProps: {
        ...linkStyle,
        css: css`
            text-align: left;
        `,
    },
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        max-width: 100%;
        margin-bottom: 10px;
    `,
};

autocompleteCategoriesStyles.focusedLink = mergeWithCss(autocompleteCategoriesStyles.link, {
    css: css`
        background-color: ${getColor("common.ui7")};
    `,
});

autocompleteCategoriesStyles.categoryItemText = {
    ...linkStyle,
    css: css`
        max-width: 100%;
        margin-bottom: 10px;
        text-align: left;
        > ${StyledButton} {
            margin-bottom: 0;
        }
    `,
};

autocompleteCategoriesStyles.focusedCategoryItemText = mergeWithCss(autocompleteCategoriesStyles.categoryItemText, {
    css: css`
        background-color: ${getColor("common.ui7")};
    `,
});

autocompleteContentStyles.headerText = autocompleteCategoriesStyles.headerText;
autocompleteContentStyles.link = autocompleteCategoriesStyles.link;
autocompleteContentStyles.focusedLink = autocompleteCategoriesStyles.focusedLink;

autocompleteBrandsStyles.headerText = autocompleteCategoriesStyles.headerText;
autocompleteBrandsStyles.link = autocompleteCategoriesStyles.link;
autocompleteBrandsStyles.focusedLink = autocompleteCategoriesStyles.focusedLink;
autocompleteBrandsStyles.brandItemText = autocompleteCategoriesStyles.categoryItemText;
autocompleteBrandsStyles.focusedBrandItemText = autocompleteCategoriesStyles.focusedCategoryItemText;
